import {Component, input, computed, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {RADIO_GROUP, RadioGroupApi} from "@common/components/inputs/radio-group/radio-group.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-radio-button",
    templateUrl: "./radio-button.component.html",
    styleUrls: ["./radio-button.component.scss"],
    imports: [FormsModule],
    exportAs: "cmRadioButton",
})
export class RadioButtonComponent<T> {
    readonly $disabled = input<boolean>(false, {alias: "disabled"})
    readonly $required = input<boolean>(false, {alias: "required"})
    readonly $value = input.required<T>({alias: "value"})
    private readonly group = inject(RADIO_GROUP, {optional: true})

    constructor() {}

    getGroup(): RadioGroupApi {
        if (!this.group) {
            throw new Error("cm-radio-button must be used inside cm-radio-group")
        }

        return this.group
    }

    readonly $checked = computed(() => this.getGroup().isSelected(this.$value()))
    readonly $name = computed(() => this.getGroup().name())
    readonly $_disabled = computed(() => this.getGroup().disabled() ?? this.$disabled())

    onChange() {
        const val = this.$value()
        this.group!.select(val)
    }
}
